import { PHONE_VALIDATION_REGEX } from '../schemas/phoneValidationRegex';

function phoneNumberIsValid(number = ''): boolean {
  return PHONE_VALIDATION_REGEX.test(number.replace(/\D/g, ''));
}

export { phoneNumberIsValid };
